import { SystemSaleyards } from "constants/sale";

import logo from "img/AgriNous-logo-base64";

export const deploymentLocationString = deployment =>
  deployment.locations
    .map(location => location.name)
    .filter(name => !SystemSaleyards.includes(name))
    .join("/");

const env = process.env.REACT_APP_ENVIRONMENT;
const isLocalEnvironment = env === "local";

export const baseImageURL = isLocalEnvironment ? window.location.origin : "";

export const deploymentLogoURL = (deployment, sale) => {
  if (isLocalEnvironment) {
    return `data:image/jpeg;base64,${logo}`;
  } else if (deployment?.placards_logo_url) {
    // This is backwards compared to the how logos are used in the backend
    // This is because we want the deployment logo on the placards at highest priority
    // so it can be shown when the placard is displayed in a saleyard.
    return `${baseImageURL}${deployment.placards_logo_url}`;
  } else if (sale?.placard_logo_url) {
    return `${baseImageURL}${sale.placard_logo_url}`;
  } else {
    return `data:image/jpeg;base64,${logo}`;
  }
};
